import { defineMessages } from 'react-intl';

export const declineCompleteIntl = defineMessages({
  h1: {
    id: '23a6341d32d9e6fd9a27e7aef8fca76ef2e147ab59e22b42f033ad37dc6a1c86',
    description:
      'text in modal of signer flow, when signer declines the signature request, the document as an signature request will close',
    defaultMessage: 'This document is now closed.',
  },
  close: {
    id: 'd1628cf5a4a7a31376b5bc2f91e55cfac37c5720caa19cfa80e04433588a650e',
    description: 'button text of iFrame , clicking will close iFrame',
    defaultMessage: 'Close',
  },
});
